/* Code generated with AutoHTML Plugin for Figma */
import { Discont, ID } from "@project/shared-types";
import React from "react";
import DiscontTicketSvg from "../../../../assets/images/ticket.svg?react";
import DiscontTicketGreenSvg from "../../../../assets/images/ticket_green.svg?react";
import DiscontTicketLeftSvg from "../../../../assets/images/ticket_left.svg?react";
import DiscontTicketLeftGreenSvg from "../../../../assets/images/ticket_left_green.svg?react";
import "./DiscontCard.css";
interface DiscontCardProps {
  isActive: boolean;
  is_green: boolean;
  discont: Discont;
  handleClick: (id: ID) => void;
}

export const DiscontCard: React.FC<DiscontCardProps> = ({
  isActive,
  discont,
  handleClick,
  is_green,
}) => {
  return (
    <div
      className={`discont-card discont-card-green-${is_green}`}
      onClick={() => handleClick(discont.id)}
    >
      <div className="discont-card-ticket">
        {is_green ? <DiscontTicketGreenSvg /> : <DiscontTicketSvg />}
        <div className="discont-card-ticket-body">
          <div className="discont-card-ticket-group">
            <p className="discont-card-text-first">– На заказ –</p>
            <p className="discont-card-text-title">скидка {discont.percent}%</p>
          </div>
          <p className="discont-card-text-footer">
            до {new Date(discont.date_close).toLocaleDateString()}
          </p>
        </div>
      </div>
      <div className={`discont-card-body discont-card-${isActive}`}>
        {is_green ? <DiscontTicketLeftGreenSvg /> : <DiscontTicketLeftSvg />}
        <p
          className={`discont-card-text-left discont-card-text-left-${isActive}`}
        >
          {isActive ? "АКТИВНА" : "ПРИМЕНИТЬ"}
        </p>
      </div>
    </div>
  );
};
